// 越南语
export default {
    Language: 'Tiếng Việt',
    system: {
        homePage: {
            title1: 'Tiêu đề 1',
            title2: 'Tiêu đề 2',
            description1: '7 ngày gần đây',
            description2: '6 tháng gần đây',
        }
    },
    login: {
        register: 'Đăng ký thành viên',
        usernamePls: 'Vui lòng nhập tên đăng nhập',
        passwordPls: 'Vui lòng nhập mật khẩu',
        toRegister: 'Chưa có tài khoản? Đăng ký ngay',
        doLogin: 'Đăng nhập',
    },
    register: {
        repasswordPls: 'Vui lòng nhập mật khẩu rút tiền',
        codePls: 'Vui lòng nhập mã mời',
        register: 'Đăng ký',
        xieyi: 'Đồng ý điều khoản sử dụng',
        xieyiPls: 'Vui lòng chọn thỏa thuận mở tài khoản!',
    },
    mine: {
        xyfs: 'Điểm tín dụng',
        ljjf: 'Điểm tích lũy',
        recharge: 'Nạp tiền',
        withdraw: 'Rút tiền',
        money: 'Số dư khả dụng',
        infomation: 'Thông tin cơ bản',
        moneylog: 'Lịch sử điểm',
        withdrawrecord: 'Chi tiết rút tiền',
        gamerecord: 'Lịch sử quà tặng',
        notice: 'Thông báo',
        mymove: 'Lịch sử xem',
        loginpwd: 'Mật khẩu đăng nhập',
        paypwd: 'Mật khẩu sử dụng',
        loginout: 'Đăng xuất',
        paypwdhasseted: 'Mật khẩu rút tiền đã được thiết lập. Nếu cần thay đổi, vui lòng liên hệ bộ phận chăm sóc khách hàng',
        setbank: 'Vui lòng thiết lập thẻ nhận tiền!',
        lorr: 'Đăng nhập/Đăng ký',
    },
    infomation: {
        username: 'ID thành viên',
        name: 'Họ tên',
        bankcard: 'Tài khoản rút tiền',
        phone: 'Số điện thoại',
        recharge: 'Nạp tiền',
        amount: 'Điểm sở hữu',
        toserve: 'Vui lòng liên hệ CSKH',
        kfms: 'Để nạp tiền offline, vui lòng liên hệ CSKH. Số tiền nạp qua một số kênh thanh toán sẽ được nạp ngẫu nhiên đến 1 chữ số thập phân, vui lòng kiểm tra kỹ khi thanh toán',
    },
    withdraw: {
        title: 'Rút tiền',
        log: 'Lịch sử rút tiền',
        method: 'Phương thức rút tiền',
        avmoney: 'Số dư có thể rút',
        limit: 'Hạn mức rút tiền',
        submit: 'Yêu cầu rút tiền',
        xiane: 'Hạn mức mỗi lần',
        numbers: 'Số lần rút tiền',
        time: 'Thời gian đến tài khoản',
        zuidi: 'Tối thiểu',
        zuigao: 'Tối đa',
        numsmax: 'Số tiền rút tối đa mỗi ngày',
        ci: 'lần',
        timedetail: 'Thời gian chuyển tiền thông thường khoảng 5 phút, nhanh nhất trong 2 phút',
        bank: 'Thẻ ngân hàng',
        status1: 'Chờ xét duyệt',
        status2: 'Thành công',
        status3: 'Thất bại',
        enterCorrectAmount: 'Vui lòng nhập số tiền chính xác',
        selectBankCard: 'Vui lòng chọn thẻ ngân hàng rút tiền',
        enterPayPassword: 'Vui lòng nhập mật khẩu thanh toán',
    },
    moneylog: {
        title: 'Chi tiết tiền',
        type1: 'Thay đổi',
        type2: 'Tiền thưởng',
        type3: 'Nhiệm vụ',
        type4: 'Tiền thưởng',
        type5: 'Rút tiền',
        type6: 'Rút tiền thất bại',
        rechargeNote: '(Nạp tiền)',
    },
    setting: {
        loginpwdtitle: 'Đổi mật khẩu đăng nhập',
        oldpwd: 'Vui lòng nhập mật khẩu cũ',
        newpwd: 'Vui lòng nhập mật khẩu mới',
        renewpwd: 'Vui lòng nhập lại mật khẩu mới',
        change: 'Thay đổi',
        plseall: 'Vui lòng điền đầy đủ thông tin!',
        pswwrong: 'Mật khẩu nhập lại không khớp',
        paypwdtitle: 'Thiết lập mật khẩu tiền',
        paypwd: 'Vui lòng nhập mật khẩu tiền',
        repaypwd: 'Vui lòng nhập lại mật khẩu tiền',
        title: 'Cài đặt',
        basicInfo: 'Cài đặt thông tin cơ bản',
        loginPassword: 'Mật khẩu đăng nhập',
        fundPassword: 'Mật khẩu tiền',
        logout: 'Đăng xuất',
        payPasswordSet: 'Mật khẩu rút tiền đã được thiết lập, cần thay đổi vui lòng liên hệ CSKH',
        payPasswordNotSet: 'Chưa thiết lập',
        payPasswordHasSet: 'Đã thiết lập',
        confirm: 'Xác nhận',
    },
    home: {
        gonggao: 'Trải nghiệm sang trọng tối thượng',
        qgkf: 'Có thể toàn quốc',
        hotlist: 'Danh sách đề xuất phổ biến',
        hotgame: 'Đề xuất nhiệm vụ',
        gaoji: 'Cao cấp',
        smrz: 'Xác thực thực tế',
        videorz: 'Xác thực video bản thân',
        star: 'Đánh giá',
        sg: 'Chiều cao',
        xw: 'Vòng ngực',
        diqu: 'Khu vực phục vụ',
        apply: 'Đăng ký hẹn hò',
        ssxz: 'Tình trạng thời gian thực',
        joinvip: 'Đã tham gia hội viên',
    },
    video: {
        title: 'Thư viện video',
        nums: 'Lượt phát',
        bofangliang: 'Lượt phát',
        hotlist: 'Đề xuất phổ biến',
        plsrefisrt: 'Vui lòng nạp tiền để xem video!',
        trialEnded: 'Xem thử đã kết thúc',
        rechargeToWatch: 'Vui lòng nạp tiền để xem miễn phí',
        goRecharge: 'Nạp tiền ngay',
    },
    choose: {
        title: 'Đêm tuyệt vời nhất',
        nav: 'Tuyển phi',
        apply: 'Đăng ký kết đôi',
        jianjie: 'Giới thiệu mỹ nữ',
        move: 'Có thể di chuyển',
        click: 'Nhấp để xác thực',
        detail: 'Thông tin chi tiết',
        videodetail: 'Video thời gian thực',
    },
    common: {
        refresh: 'Làm mới thành công',
        noallow: 'Chức năng đã bị vô hiệu hóa!',
        disable: 'Vô hiệu hóa',
        all: 'Tất cả',
        nomore: 'Không còn nữa',
        nodata: 'Không có dữ liệu',
        submit: 'Gửi',
        more: 'Xem thêm',
        pinglunnav: 'Bình luận',
        pingluntitle: 'Bình luận',
        pldtitle: 'Chi tiết bình luận',
        minenav: 'Tài khoản',
        homenav: 'Trang chủ',
        addbank: 'Thêm thẻ nhận tiền',
        setbank: 'Tài khoản rút tiền',
    },
    game: {
        expect: 'Số kỳ',
        jieguo: 'Dữ liệu',
        da: 'Lớn',
        xiao: 'Nhỏ',
        dan: 'Lẻ',
        shuang: 'Chẵn',
        大: 'Lớn',
        小: 'Nhỏ',
        单: 'Lẻ',
        双: 'Chẵn',
        order: 'Đơn nhiệm vụ',
        clear: 'Xóa đơn hàng',
        submit: 'Xác nhận gửi',
        kjcc: 'Mở thưởng thành công, số kỳ:',
        lxgly: 'Vui lòng liên hệ quản lý của bạn',
        plsmoney: 'Vui lòng nhập số tiền!',
        plsnum: 'Vui lòng chọn số!',
        moneynote: 'Số dư không đủ, vui lòng liên hệ CSKH để nạp tiền!',
        lefttime: 'Thời gian còn lại',
        lunci: 'Số kỳ',
        workRecord: 'Lịch sử nhiệm vụ',
        day: 'Ngày',
        period: 'Kỳ',
        allWork: 'Tất cả nhiệm vụ',
        reset: 'Đặt lại',
        confirm: 'Xác nhận',
        bonusPoints: 'Điểm thưởng',
        missionMoney: 'Chi tiết số tiền nhiệm vụ',
        missionResult: 'Kết quả nhiệm vụ',
        points: 'Điểm',
        workPoints: 'Điểm nhiệm vụ',
        giftCompleted: 'Quà tặng đã hoàn thành',
        orderTime: 'Thời gian đặt hàng:',
        detail: 'Chi tiết',
        content: 'Nội dung',
        amount: 'Số tiền',
        result: 'Kết quả',
        time: 'Thời gian',
        win: 'Thắng',
        missionFailed: 'Nhiệm vụ thất bại',
    },
    kefu: {
        title: 'CSKH trực tuyến',
        lianxi: 'Liên hệ',
        content: 'Phục vụ 24/7',
        defaultName: 'CSKH trực tuyến',
    },
    setname: {
        title: 'Sửa tên thật',
        xingming: 'Tên',
        tips: 'Vì sự an toàn tài khoản của bạn, tên thật phải khớp với tên trên thẻ ngân hàng liên kết',
        xmpls: 'Vui lòng nhập tên thật',
        save: 'Lưu',
        notreset: 'Không được thiết lập lại!',
        plsentername: 'Vui lòng nhập tên!',
    },
    withdrawCenter: 'Trung tâm rút tiền',
    withdrawRecord: 'Lịch sử rút tiền',
    withdrawAmount: 'Số tiền rút',
    allMoney: 'Tất cả',
    singleLimit: 'Hạn mức mỗi lần',
    lowest: 'Thấp nhất',
    highest: 'Cao nhất',
    withdrawTimes: 'Số lần rút tiền',
    maxDailyWithdraw: 'Rút tối đa một ngày',
    times: 'lần',
    arrivalTime: 'Thời gian đến tài khoản',
    limitDescription: 'Mô tả hạn mức',
    balance: 'Số dư',
    withdrawNow: 'Rút tiền ngay',
    enterCorrectAmount: 'Vui lòng nhập số tiền chính xác',
    personalReport: 'Báo cáo cá nhân',
    profitAmount: 'Số tiền lợi nhuận',
    profitFormula: 'Công thức tính lợi nhuận: Số tiền trúng thưởng - Số tiền nhiệm vụ',
    taskAmount: 'Số tiền nhiệm vụ',
    accountOffline: 'Tài khoản ngoại tuyến',
    loginRegister: 'Đăng nhập/Đăng ký',
    loginForMore: 'Đăng nhập để hưởng thêm dịch vụ!',
    author: 'Tác giả:',
    notification: 'Thông báo',
    changePhone: 'Đổi số điện thoại',
    save: 'Lưu',
    existingPhone: 'Số điện thoại hiện tại',
    newPhone: 'Số điện thoại mới',
    withdrawAccountRegister: 'Đăng ký tài khoản rút tiền',
    selectBankCard: 'Vui lòng chọn thẻ ngân hàng',
    accountNumber: 'Số tài khoản',
    enterBankCardNumber: 'Vui lòng nhập số thẻ ngân hàng',
    systemNotice: 'Thông báo hệ thống',
    myMovie: 'Phim của tôi',
    completeTaskForMore: 'Hoàn thành nhiệm vụ để nhận thêm vé xem phim',
    movieTicket: 'Vé xem phim:',
    watchList: 'Danh sách xem',
    noDataYet: 'Chưa có dữ liệu',
    setNameFirst: 'Vui lòng thiết lập tên trước khi liên kết tài khoản rút tiền!',
    setPasswordFirst: 'Vui lòng thiết lập mật khẩu rút tiền trước khi liên kết thẻ ngân hàng!',
    accountHolder: 'Chủ tài khoản',
    enterRealName: 'Vui lòng nhập tên thật',
    withdrawPassword: 'Mật khẩu rút tiền',
    registerWithdrawPassword: 'Vui lòng đăng ký mật khẩu rút tiền',
    bankCard: 'Thẻ ngân hàng',
    orderContentLabel: 'Nội dung đơn hàng:',
    all: 'Tất cả',
    bonusPointsLabel: 'Điểm thưởng',
    waitingResultLabel: 'Đang chờ kết quả',
    missionMoneyDetails: 'Chi tiết số tiền nhiệm vụ',
    points: 'Điểm',
    switch: 'Công tắc',
    currentSelection: 'Lựa chọn hiện tại:',
    quantity: 'Số lượng:',
    total: 'Tổng cộng',
    ticketAmount: 'Số vé',
    availablePoints: 'Điểm khả dụng',
    verify: 'Xác thực',
    possible: 'Có thể',
    thumb: 'Ngón tay cái',
    privacyPolicy: 'Chính sách bảo mật',
    romanticDescription: 'Dịch vụ lãng mạn của chúng tôi để bảo vệ thông tin cá nhân của thành viên, chỉ có thể đăng ký thông qua dịch vụ xác thực danh tính hoặc được giới thiệu bởi thành viên đã xác thực.',
    person1: 'Hạ Vũ',
    person2: 'Mẫn Tuyết',
	lishijl: 'Lịch sử ghi chép'
};